import React from "react";
import { useSelector } from "react-redux";
import SvgTick from "../../assets/icons/SvgTick";
import UseColors from "../../staticQueries/useColors";
import { getColors } from "../../utils/getColors";
import { COLORS } from "./constants";
import { AccordionContent } from "@/components/ui/accordion";

const Color = ({ colorNames, handleClick }) => {
  const { filter } = useSelector((state) => state.filter);
  const colors = UseColors();
  const matchedColors = getColors(colorNames, colors);

  return (
    <AccordionContent className="pb-[15px] text-sm tracking-wide leading-[25px]">
      {matchedColors.map((color, index) => (
        <div
          key={index}
          className="rounded-full w-[30px] h-[30px] inline-flex justify-center items-center bg-primary-300 my-[6px] mx-[6px] relative
          bg-center"
          role="button"
          title={color?.name}
          style={{
            backgroundImage: `url(${color.url})`,
          }}
          onClick={() => handleClick(COLORS, color.name)}
        >
          {filter.colors?.includes(color?.name) && (
            <SvgTick
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                height: "9px",
                width: "9px",
                fill: "white",
              }}
            />
          )}
        </div>
      ))}
    </AccordionContent>
  );
};

export default Color;
